import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    MeetingProvider,
    MeetingConsumer,
    useMeeting,
    useParticipant,
} from "@videosdk.live/react-sdk";
import ReactPlayer from "react-player";

const ParticipantView = (props) => {
    // const micRef = useRef(null);
    const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } =
        useParticipant(props.participantId);

    const videoStream = useMemo(() => {
        if (webcamOn && webcamStream) {
            const mediaStream = new MediaStream();
            mediaStream.addTrack(webcamStream.track);
            return mediaStream;
        }
    }, [webcamStream, webcamOn]);

    return (
        <div className="col-lg-6 col-md-12 video-meet-sec " style={{ height: 'max-content' }}>


            {/* <audio ref={micRef} autoPlay playsInline muted={isLocal} /> */}
            {webcamOn ? (
                <><ReactPlayer
                    //
                    playsinline // extremely crucial prop
                    pip={false}
                    light={false}
                    controls={false}
                    muted={true}
                    playing={true}
                    //
                    url={videoStream}
                    //
                    height={"22rem"}
                    width={"100%"}
                    onError={(err) => {
                        console.log(err, "participant video error");
                    }} /></>
            )
                :
                <div className="bg-secondary participant-logo-pic" style={{ height: '22rem', width: '100%', borderRadius: '10px' }}>
                    <h1> {displayName?.slice(0, 1).toUpperCase()} </h1></div>
            }
            <p>
                {displayName} | {webcamOn ? <i className="mx-1 white-icon fas fa-video"></i> : <i className="mx-1 white-icon fas fa-video-slash"></i>} |
                {micOn ? <i className="mx-1 white-icon fa fa-microphone"></i> : <i className="mx-1 white-icon fa fa-microphone-slash"></i>}
            </p>

        </div>
    );
}

export default ParticipantView